import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../api';

const s = {
    root:  { minHeight: '100vh', background: '#050810', display: 'flex', flexDirection: 'column', fontFamily: '"Segoe UI", system-ui, sans-serif' },
    nav:   { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 48px', borderBottom: '1px solid rgba(29,78,216,0.15)' },
    logo:  { display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' },
    center:{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' },
    box:   { width: '100%', maxWidth: 380, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(29,78,216,0.2)', borderRadius: 20, padding: '40px 36px' },
    h1:    { fontSize: 26, fontWeight: 800, color: '#f1f5f9', marginBottom: 6, letterSpacing: '-0.5px' },
    sub:   { fontSize: 14, color: '#64748b', marginBottom: 32 },
    lbl:   { display: 'block', fontSize: 13, fontWeight: 600, color: '#94a3b8', marginBottom: 6, marginTop: 20 },
    inp:   { width: '100%', padding: '12px 14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, fontSize: 14, color: '#f1f5f9', outline: 'none', boxSizing: 'border-box' },
    err:   { marginTop: 16, padding: '12px 14px', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, color: '#fca5a5', fontSize: 13, textAlign: 'center' },
    ok:    { marginTop: 16, padding: '12px 14px', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: 8, color: '#6ee7b7', fontSize: 13, textAlign: 'center' },
    btn:   { width: '100%', marginTop: 28, padding: '13px 0', border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 15, cursor: 'pointer' },
    back:  { textAlign: 'center', marginTop: 24, fontSize: 14, color: '#64748b' },
    backL: { color: '#60a5fa', cursor: 'pointer', fontWeight: 600 },
};

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [password, setPassword]   = useState('');
    const [confirm, setConfirm]     = useState('');
    const [error, setError]         = useState('');
    const [done, setDone]           = useState(false);
    const [loading, setLoading]     = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        if (password !== confirm) return setError('Passwords do not match.');
        if (password.length < 8) return setError('Password must be at least 8 characters.');
        setLoading(true);
        setError('');
        try {
            await resetPassword(token, password);
            setDone(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Something went wrong. Try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div style={s.root}>
                <div style={s.center}>
                    <div style={s.box}>
                        <div style={s.err}>Invalid reset link. Please request a new one.</div>
                        <div style={s.back}><span style={s.backL} onClick={() => navigate('/forgot-password')}>Request new link</span></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={s.root}>
            <nav style={s.nav}>
                <div style={s.logo} onClick={() => navigate('/')}>
                    <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 36, width: 'auto', borderRadius: 8 }} />
                </div>
            </nav>
            <div style={s.center}>
                <div style={s.box}>
                    <h1 style={s.h1}>Set new password</h1>
                    <p style={s.sub}>Choose a strong password for your account.</p>

                    {error && <div style={s.err}>{error}</div>}
                    {done && (
                        <div style={s.ok}>
                            ✅ Password updated! Redirecting to login...
                        </div>
                    )}

                    {!done && (
                        <form onSubmit={submit}>
                            <label style={s.lbl}>New Password</label>
                            <input
                                style={s.inp}
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required autoFocus
                                placeholder="Min. 8 characters"
                                minLength={8}
                            />
                            <label style={s.lbl}>Confirm Password</label>
                            <input
                                style={s.inp}
                                type="password"
                                value={confirm}
                                onChange={e => setConfirm(e.target.value)}
                                required
                                placeholder="Repeat password"
                            />
                            <button
                                type="submit"
                                className="og-btn-primary"
                                style={{ ...s.btn, opacity: loading ? 0.7 : 1 }}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Set New Password →'}
                            </button>
                        </form>
                    )}

                    <div style={s.back}>
                        <span style={s.backL} onClick={() => navigate('/login')}>&larr; Back to login</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
